import { getResourceFile } from '@mote/helpers/misc'
import { Block } from '../block/block'

export const NonIdealState = ({
  children,
  height = 'calc(100vh - 568px)',
  imageProps = {},
  ...rest
}) => {
  return (
    <Block
      align='center'
      justify='center'
      maxWidth={540}
      gap={40}
      height={height}
      margin='0 auto 40px auto'
      {...rest}
    >
      <img
        alt='Something went wrong'
        {...imageProps}
        src={getResourceFile('/images/illustrations/non-ideal-state.svg')}
      />
      {children}
    </Block>
  )
}
